import * as React from 'react';
import { ExportsViewItem } from './exports-view-item';
import styles from '../../my-downloads.scss';
import { actionCreators } from './actions';
import { ExportsViewState } from 'app/area/my-downloads/exports/exports-view/types-store';
import { Timer } from 'app/components/timer/timer';
import { ElementLoader } from 'ui';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { STATE } from 'app/constants';
import { exportsTranslations, exportStatusPollingInterval } from './constants';

export type ExportsContainerProps = ExportsViewState & typeof actionCreators & DefaultContainerProps;

export class ExportsComponent extends React.Component<ExportsContainerProps, void> {
  public static statePath: string = STATE.myDownloads;

  private renderExportsList = () => {
    const {
      exportsView: {
        download,
        exportStatus
      }
    } = this.props;

    return [...exportStatus].map((item, index) =>
      <div key={index} className={styles.myDownloadsListItem}>
        <ExportsViewItem
          {...this.props}
          download={download}
          exportId={item.exportId}
          status={item.status}
          exportStartedAt={item.exportStartedAt}
          numberOfCases={item.numberOfCases}
          comments={item.comments}
          contentType={item.contentType} />
      </div>);
  };

  public render() {
    const {
      exportsView: {
        exportStatus
      },
      translation
    } = this.props;

    const displayExportList = exportStatus && exportStatus.length > 0
      ? this.renderExportsList()
      : (!this.props.exportsView.exportStatus
        ? <ElementLoader />
        : <div className="no-content">{translation.exports_no_data}</div>);

    return (<div className={styles.myDownloadsWrapper}>
      <h3 className={styles.downloadHeading}>{translation.export_title} </h3>
      <Timer
        callback={this.props.loadExportStatus}
        interval={exportStatusPollingInterval}>
        {displayExportList}
      </Timer>
    </div>);
  }
}

const container = containerFactory(ExportsComponent, actionCreators, {}, exportsTranslations);

export { container as ExportsView };
